<template>
  <div class="w-80 space-y-4 bg-white p-3 shadow-popover">
    <lf-h4>{{ $t("DEALS.SOURCE.TITLE") }}</lf-h4>
    <ul class="space-y-4 text-headline">
      <template v-for="(sourceArray, service) in sources" :key="service">
        <li
          v-for="source in sourceArray"
          :key="source"
          :data-cy="source"
          class="flex items-center space-x-2"
        >
          <img :src="serviceImage(source)" class="h-4 w-4" />
          <span class="truncate">
            {{ startCase(camelCase(source)) }}
          </span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
import camelCase from "lodash/camelCase";
import startCase from "lodash/startCase";

import { getProviderImageByServiceName } from "@/helpers/services";

defineProps<{
  sources: Record<string, string[]>;
}>();

const serviceImage = (name: string) => {
  return getProviderImageByServiceName(name) || "";
};
</script>
